import React, {Component} from 'react';
import config from './../../../config';

class Prizes extends Component {
    onPrizeTap = () => {
        const article_id = {
            en: "2568611",
            es: "2568628",
            fr: "2568649",
            de: "2568626",
            it: "2568675",
            pt: "2568630",
            ru: "2568625"
        };
        // const url = 'https://www.uefa.com/news/newsid={{ARTICLE_ID}}.html';
        var url = config.article_id['prizes'][config.CURRENT_LANGUAGE].replace(
          '{{boolean}}',
          config.isMobile ? 'true' : 'false'
        )
        window.open(url);
    };

    render() {
        let trans = this.props.trans;
        let sMobClass = this.props.jDesktopOrder ? '' : 'si-mob';
        return (<div className={"si-card si-prizes-card " + sMobClass}>
            <div className="si-prizes-main">
                <div className="si-ps-block"><img src={(config.playerImgBase + "homepage/PS4_logo@1x.png")} alt={""}/>
                </div>
                <div className="si-sponsor"><img src={(config.playerImgBase + "homepage/prizes@1x.png")} alt={""}/>
                </div>
            </div>
            <div className="si-main-text-block">
                <div className="text-block">
                    <div className="si-text-title">{trans.pcHeading}</div>
                    <div className="si-text-descp">{trans.pcMessage}</div>
                </div>
                <div className="button-block">
                    <div className="si-btn btn-lg" onClick={() => this.onPrizeTap()}>{trans.prizeLabel}</div>
                </div>
            </div>
        </div>);
    }
}

export default Prizes;


// WEBPACK FOOTER //
// ./src/components/home/cards/Prizes.js